export enum GlobalSettingType {
    Unknown = 0,
    CompanyDisplayName = 1,
    CompanyLogo = 2,
    CompanyReservationComponent = 3,
    CompanyMailChimpDetails = 4,
    ShowReservationType1EarlyBirdAgreedPurchasePrice = 5,
    ShowReservationType1EarlyBirdAnticipatedCompletionDate = 6,
    ShowReservationType1EarlyBirdDrawingNumbers = 7,
    ShowReservationType1PersonName = 8,
    ReservationType1DropdownMonth = 9,
    ReservationType1LegalCopy = 10,
    ReservationType1ChecklistVersion = 11,
    RegisteredLandOwner = 12,
    DeveloperName = 13,
    ShowDatePicker = 14,
    ShowReservationType1EarlyBirdReservationFee = 15,
    ShowReservationType1ChecklistCountryType = 16,
    EnableCustomerPortalAccess = 17,
    EnableEmailTemplates = 19,
    ShowReservationType1FinancialDepositDueAt = 20,
    AllowDrawingManagement = 21,
    AllowStripePayments = 22,
    WarrantyCountdownInYears = 23,
    AllowWordPress = 24,
    ShowAlternativeFinanceReport = 25,
    ShowFullReservationFormV1 = 26,
    ShowFullReservationFormV2 = 27,
    AllowThirdFortIntegration = 28,
    ShowChoicesSum = 29,
    CompanyCampaignMonitorDetails = 30,
    ShowNoticesOnDevelopment = 31,
    ShowSiteDiary = 32,
    ShowRFI = 33,
    BespokeCustomerPortalLink = 34,
    Spotler = 35,
    TinyMCEAPIKey = 36,
    AllowRightmoveADFIntegration = 37,
    SiteWideDocuments = 38,
    Office365EmailCapture = 39,
    Esendex = 40,
    TwoFactorAuthentication = 41,
    AllowOnTheMarketLeads = 42,
    NewHomesForSale = 43,
    ContactSoftDelete = 44,
    ContactMonitorInactivity = 45,
    LegallyCompleteArchiveEnable = 46,
    PropertySoftDelete = 47,
    AllowWordPressBatchUpdater = 48,
    MarketingProvider = 49,
    CompanyEmailOctopusDetails = 50,
    PaymentProvider = 51,
    WorldpayTestEnvironment = 52,
}
